const MuiSelect = {
  root: {
    padding: 13
  },
  select: {
    '&:focus': {
      backgroundColor: 'unset'
    }
  },
  outlined: {
    borderRadius: 5
  }
};
export default MuiSelect;